import React from "react";
import { Link } from "react-router-dom";
import Seo from "../seo/Seo";
import { Section, Heading, PageHero, CTASection } from "../components/ui-kit";
import { IMAGES } from "../mock/mock";
import { COUNTIES, CITIES } from "../data/site";

const breadcrumbs = [{ name: "Home", path: "/" }, { name: "Locations", path: "/locations" }];

const Locations = () => (
  <>
    <Seo
      title="Custom Home Builder Service Areas in Central Florida | Build Highland Homes"
      description="Build Highland Homes builds custom homes across Central Florida — Brevard, Orange, Osceola, Seminole, and Volusia counties. Explore our service areas and city pages."
      path="/locations"
      keywords="custom home builder central florida, custom home builder near me, service areas, brevard orange osceola seminole volusia"
      breadcrumbs={breadcrumbs}
    />
    <PageHero overline="Where We Build" title="Custom Home Builder Serving Central Florida" subtitle="We design and build custom homes on your lot across five Central Florida counties. Explore each county and the cities we serve." image={IMAGES.farmhouseAerial} />

    <Section className="bg-[#0b0b0b]">
      <div className="space-y-10">
        {COUNTIES.map((c) => (
          <div key={c.slug} className="bg-[#141414] border border-[#c9a24b]/15 p-7 md:p-9">
            <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
              <h2 className="font-serif-display text-3xl text-[#e3c77a]"><Link to={`/locations/${c.slug}`} className="hover:underline">{c.name}</Link></h2>
              <Link to={`/locations/${c.slug}`} className="text-sm text-[#c9a24b] hover:text-[#e3c77a]">View {c.name} →</Link>
            </div>
            <p className="text-[#a39d90] leading-relaxed mb-5">{c.intro}</p>
            <div className="flex flex-wrap gap-2">
              {c.cities.map((city) => {
                const slug = city.toLowerCase().replace(/[^a-z0-9]+/g, "-");
                return CITIES[slug]
                  ? <Link key={city} to={`/locations/${slug}`} className="text-xs border border-[#c9a24b]/40 text-[#e3c77a] hover:bg-[#c9a24b] hover:text-[#0b0b0b] px-3 py-1.5 transition-colors">{city}</Link>
                  : <span key={city} className="text-xs border border-white/10 text-[#8a857a] px-3 py-1.5">{city}</span>;
              })}
            </div>
          </div>
        ))}
      </div>
    </Section>

    <CTASection />
  </>
);

export default Locations;
